import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
import '../masters/basic.css'
import httpService from '../../setup/http/httpServices'
import { Input, message } from 'antd'
import Select from 'react-select'
import { KTSVG, toAbsoluteUrl } from '../../_metronic/helpers'
import _ from 'lodash'
import { handleFileUpload } from '../../setup/Upload/Upload'
import ComponentTopBreadCrumb from './ComponentTopBreadCrumb'
import { Modal } from 'react-bootstrap-v5'
import { log } from 'console'

interface Params {
    id: string;
}


const AddComponents = () => {
    const history: any = useHistory()
    const [loading, setLoading] = useState(false)
    const [counter, setCounter] = useState(Array(1).fill(0))
    const [show, setShow] = useState(false)
    const [deleteId, setDeleteId] = useState('')
    const [toggleCrop, setToggleCrop] = useState(false)
    const [phraseInput, setPhraseInput] = useState('')
    const [phraseInputEdit, setPhraseInputEdit] = useState('')
    const [pages, setPages] = useState([{ value: '', label: 'Select Framework' }])
    const [categories, setCategories] = useState([{ value: '', label: 'Select Framework' }])
    const [subCategories, setSubCategories] = useState([{ value: '', label: 'Select Framework' }])
    const [values, setValues] = useState([
        {
            _id: '',
            websiteUrl: '',
            websiteId: '',
            Category: {
                value: '',
                label: 'Select Category'
            },
            websiteName: '',
            componentMobileSS: '',
            componentDesktopSS: '',
            filesM: [],
            filesD: [],
            componentPhrases: []
        },
    ])

    console.log('values', values)

    const params = useParams<Params>()
    const websiteId = params.id;

    const [errorArray, setErrorArray] = useState([false])
    const [deskfetchErr, setDeskFetchErr] = useState(false)
    const [editErr, setEditErr] = useState(false)
    const [editPhraseErr, setEditPhraseErr] = useState(false)

    const [compErr, setCompErr] = useState(false)
    const [phraseErr, setPhraseErr] = useState(false)

    const [manualWeb, setManualWeb] = useState(false)
    const [manualMob, setManualMob] = useState(false)
    const [previous, setPrevious] = useState(0)
    const [submitError, setSubmitError] = useState(false)

    const [websites, setWebsites] = useState([{ value: '', label: 'Select Website', Name: '' }])




    const [editData, setEditData] = useState<any>()
    const [editIndex, setEditIndex] = useState<number>()

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);





    const onChange = async (event: any, i: any) => {
        // const d = await handleFileUpload(event, 675, 1200);
        const d = await handleFileUpload(event);
        const a = [...values]
        a[i].componentDesktopSS = d;
        setValues(a)
    }
    const onChangeMobile = async (event: any, i: any) => {
        // const d = await handleFileUpload(event, 400, 750);
        const d = await handleFileUpload(event);
        const a = [...values]
        a[i].componentMobileSS = d;
        setValues(a)
    }

    const onChangeEdit = async (event: any) => {
        // const d = await handleFileUpload(event, 675, 1200);
        const d = await handleFileUpload(event);
        setEditData({ ...editData, componentDesktopSS: d })
    }
    const onChangeMobileEdit = async (event: any) => {
        // const d = await handleFileUpload(event, 400, 750);
        const d = await handleFileUpload(event);
        setEditData({ ...editData, componentMobileSS: d })
    }

    const getWebsites = async () => {
        let m;
        httpService.getData(
            '/website',
            (res) => {
                console.log(res.data);
                const arr = []
                for (const i of res.data.websites) {
                    const obj = {
                        label: i.url,
                        value: i._id,
                        Name: i.title
                    }
                    arr.push(obj)
                }
                setWebsites(arr)
            },
            (err) => {
                console.log(err);
            }
        )
        httpService.getData(
            '/components-master',
            (res) => {
                console.log(res.data.data.data)
                let x = []
                res.data.data.data.forEach((data) => {
                    x.push({ value: data._id, label: data.Name })
                })
                m = x;
                setSubCategories(x)

                if (history.location.state?.edit) {
                    httpService.getData(
                        '/associated-component/url?websiteUrl=' + history.location.state.data.websiteUrl,
                        (res) => {
                            console.log(res.data);

                            if (res.data.data.associatedComponent.length === 0) {
                                setValues(
                                    [
                                        {
                                            _id: '',
                                            websiteUrl: '',
                                            websiteId: '',
                                            Category: {
                                                value: '',
                                                label: 'Select Category'
                                            },
                                            websiteName: '',
                                            componentMobileSS: '',
                                            componentDesktopSS: '',
                                            filesM: [],
                                            filesD: [],
                                            componentPhrases: []
                                        },
                                    ]
                                )
                            }
                            else {
                                const arr = []
                                for (const i of res.data.data.associatedComponent) {
                                    const obj = {
                                        websiteUrl: i.websiteUrl,
                                        websiteId: i.websiteId,
                                        _id: i._id,
                                        websiteName: i.websiteName,
                                        componentMobileSS: i.componentMobileSS,
                                        componentDesktopSS: i.componentDesktopSS,
                                        componentPhrases: i.componentPhrases,
                                        Category: m.find((x: any) => x.value === i.componentCategoryId)
                                    }
                                    arr.push(obj)
                                }
                                arr.push(
                                    {
                                        websiteUrl: arr[0].websiteUrl,
                                        websiteId: arr[0].websiteId,
                                        _id: '',
                                        Category: {
                                            value: '',
                                            label: 'Select Category'
                                        },
                                        websiteName: arr[0].websiteName,
                                        componentMobileSS: '',
                                        componentDesktopSS: '',
                                        componentPhrases: []
                                    }
                                )

                                setValues(arr)
                                console.log("arr", arr)
                            }
                            // setSelectedWebsite(res.data.data.websiteDetails)

                            // let a = []
                            // res.data.data.AssociatedPages.forEach((x) => {
                            //   a.push({value: x.PageLink, label: x.PageLink})
                            // })
                            // setPages(a)

                        },
                        (err) => {
                            message.error('Not able to fetch websites.')
                        }
                    )
                }
            },
            (err) => {
                message.error('Not able to fetch.')
            }
        )
    }

    const handleEdit = async () => {
        const EA = [...errorArray]
        if (
            _.isEqual(editData, {
                websiteUrl: '',
                websiteId: '',
                Category: {},
                websiteName: "",
                componentMobileSS: '',
                componentDesktopSS: '',
                componentPhrases: []
            }) ||
            editData.websiteUrl === '' ||
            _.isEmpty(editData.Category) ||
            _.isEmpty(editData.websiteName) ||
            _.isEmpty(editData.websiteId) ||
            _.isEmpty(editData.componentMobileSS) ||
            _.isEmpty(editData.componentDesktopSS) ||
            _.isEmpty(editData.componentPhrases)
        ) {
            EA[editIndex] = true
            setSubmitError(true)
            return;
        } else {
            EA[editIndex] = false
        }
        httpService.patchData(
            "/associated-component/" + editData._id,
            {
                ...editData,
                componentCategoryId: editData.Category.value,
                componentCategoryName: editData.Category.label
            },
            (res) => {
                console.log(res.data)
                message.success("Edited Successfully")
                setEditData({})
                setEditIndex(-1)
                getWebsites()
            },
            (err) => {
                message.error("failed to edit")
            }
        )
    }
    const handleDelete = async (_id: any) => {
        httpService.deleteData(
            "/associated-component/" + deleteId,
            (res) => {
                console.log(res.data)
                message.success("Deleted Successfully")
                handleClose()
                setDeleteId('')
                setEditData({})
                setEditIndex(-1)
                getWebsites()
            },
            (err) => {
                message.error("failed to Delete")
            }
        )
    }

    useEffect(() => {
        getWebsites()
    }, [])


    useEffect(() => {
        httpService.getData(
            '/components-master',
            (res) => {
                console.log(res.data.data.data)
                let x = []
                res.data.data.data.forEach((data) => {
                    x.push({ value: data._id, label: data.Name })
                })
                setSubCategories(x)
            },
            (err) => {
                message.error('Not able to fetch.')
            }
        )
    }, [])

    //   useEffect(() => {
    //     httpService.getData(
    //       '/website/' + websiteId,
    //       (res) => {
    //         console.log(res.data.data)
    //         let a = []
    //         res.data.data.AssociatedPages.forEach((x) => {
    //           a.push({ value: x.PageLink, label: x.PageLink })
    //         })
    //         setPages(a)
    //       },
    //       (err) => {
    //         message.error('Not able to fetch.')
    //         console.log(err)
    //       }
    //     )
    //     httpService.getData(
    //       '/type-master',
    //       (res) => {
    //         console.log(res.data.data.data)
    //         let x = []
    //         res.data.data.data.forEach((data) => {
    //           x.push({ value: data._id, label: data.Name })
    //         })
    //         setCategories(x)
    //       },
    //       (err) => {
    //         message.error('Not able to fetch.')
    //       }
    //     )
    //     httpService.getData(
    //       '/components-master',
    //       (res) => {
    //         console.log(res.data.data.data)
    //         let x = []
    //         res.data.data.data.forEach((data) => {
    //           x.push({ value: data._id, label: data.Name })
    //         })
    //         setSubCategories(x)
    //       },
    //       (err) => {
    //         message.error('Not able to fetch.')
    //       }
    //     )
    //   }, [websiteId])

    const submitForm = () => {
        // e.preventDefault()
        console.log(values)
        let websiteUrl = []
        let MyCategory = []


        let array = []
        let EA = []

        values.forEach((v, i) => {


            if (
                _.isEqual(v, {
                    websiteUrl: '',
                    websiteId: '',
                    Category: {},
                    websiteName: "",
                    componentMobileSS: '',
                    componentDesktopSS: '',
                    componentPhrases: []
                }) ||
                v.websiteUrl === '' ||
                _.isEmpty(v.Category) ||
                _.isEmpty(v.websiteName) ||
                _.isEmpty(v.websiteId) ||
                // _.isEmpty(v.componentMobileSS) ||   // optional
                // _.isEmpty(v.componentDesktopSS) ||   //optional
                _.isEmpty(v.componentPhrases)
            ) {
                EA[i] = true
                setSubmitError(true)
            } else {
                EA[i] = false
            }
        })

        const fd = {
            ...values[values.length - 1],
            componentCategoryId: values[values.length - 1].Category?.value,
            componentCategoryName: values[values.length - 1].Category?.label,
            componentStatus: "EXISTING"
        }

        delete fd.Category

        setErrorArray(EA)

        if (_.isEqual(EA, Array(values.length).fill(false))) {
            console.log(submitError, errorArray)
            setLoading(true)
            httpService.postData(
                '/associated-component',
                fd,
                (res) => {
                    const data = res.data.data
                    console.log(data)
                    message.success('Success!')
                    setLoading(false)
                    // httpService.postData(
                    //   '/website/save/' + history.location.state.id,
                    //   {data},
                    //   (res) => {
                    //     setLoading(false)
                    //   },
                    //   (err) => {
                    //     setLoading(false)
                    //     message.error(err.message)
                    //   }
                    // )


                    let z = [...errorArray]
                    z.push(false)
                    setErrorArray(z)
                    if (!history.location.state?.edit) {
                        history.push({
                            pathname: '/website/add-components-new',
                            state: { data: { websiteUrl: values[0]?.websiteUrl }, edit: true },
                        });
                    }

                    getWebsites()
                },
                (err) => {
                    setLoading(false)
                    console.log(err)
                }
            )
        }
    }
    useEffect(() => {
        console.log(values)
        setSubmitError(false)
        setErrorArray(Array(values.length).fill(false))
        // console.log(errorArray)
    }, [values])

    useEffect(() => {
        console.log(errorArray)
    }, [errorArray])


    // useEffect(() => {
    //   console.log(history)
    //   console.log(process.env.REACT_APP_API_URL.split('/api/v1')[0])

    //   let AssociatedComponents = history.location.state.website.AssociatedComponent
    //   AssociatedComponents?.forEach((component) => {
    //     component['filesM'] = []
    //     component['filesD'] = []
    //   })
    //   console.log(AssociatedComponents)
    //   setPrevious(AssociatedComponents.length)
    //   if (AssociatedComponents.length !== 0) {
    //     setValues(AssociatedComponents)
    //     setCounter(Array(AssociatedComponents.length).fill(0))
    //     setErrorArray(Array(AssociatedComponents.length).fill(false))
    //   }
    // }, [history])
    const [nameError, setNameError] = useState(false)



    return (
        <div>
            {/* <div className="CompanyDetailsOuter">
        <form className='CompanyDetails'>
          <div className='row'>
            <div className='col '>
              <h6 className='fw-bold required'>Select Website</h6>
              <Select
                isMulti={false}
                name='website'
                options={websiteOpt}
                placeholder='Select Website'
                onChange={e => {
                  console.log(websites.find(x => x._id === e.value).AssociatedComponent)
                  setValues(websites.find(x => x._id === e.value).AssociatedComponent)
                  setSelectedWebsite(websites.find(x => x._id === e.value))
                }}
                className={clsx(
                  'text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect'
                )}
              />
            </div>
          </div>

        </form>
      </div> */}
            {/* <div className='CompanyDetailsOuter'>
        <h2 className='text-left mt-4' style={{ textAlign: 'left', width: '60vw' }}>Associated Components {'>'} {selectedWebsite?.title}</h2>
      </div> */}

            <ComponentTopBreadCrumb state={1} />
            <div className='CompanyDetailsOuter border '>
                <div
                    className=''
                    style={{ marginBottom: '200px' }}
                >

                    <div className="CompanyDetails">
                        <div className="">
                            <div className="row">
                                <div className='col '>
                                    <h6 className='fw-bold required'>Enter Website URL</h6>
                                    <Select
                                        options={websites}
                                        placeholder='Select Category'
                                        className={clsx(
                                            'text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect p-3 h-50px'
                                        )}
                                        styles={{
                                            menuList: (provided, state) => ({
                                                ...provided,
                                                height: 'auto',
                                                maxHeight: '200px',
                                            }),
                                        }}
                                        value={{ value: values[0].websiteId, label: values[0].websiteUrl }}
                                        // onChange={e => {
                                        //     const x = [...values]
                                        //     x[0].websiteUrl = e.label
                                        //     x[0].websiteId = e.value
                                        //     setValues(x)
                                        // }}

                                        onChange={e => {
                                            const selectedWebsite = websites.find(website => website.value === e.value);
                                            if (selectedWebsite) {
                                                const updatedValues = [{
                                                    ...values[0],
                                                    websiteUrl: selectedWebsite.label,
                                                    websiteId: selectedWebsite.value,
                                                    websiteName: selectedWebsite.Name
                                                }];
                                                setValues(updatedValues);
                                            }
                                        }}
                                    />
                                </div>
                                <div className='col '>
                                    <h6 className='fw-bold required'>Enter Website Name</h6>
                                    <Input
                                        placeholder='Website Name'
                                        className={clsx(
                                            'text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect p-3'
                                        )}
                                        style={{
                                            height: '50px',
                                        }}
                                        value={values[0].websiteName}
                                        onChange={(e) => {
                                            if (values.length > 1) return;
                                            let x = [...values]
                                            x[0].websiteName = e.target.value
                                            setValues(x)
                                        }
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {values.map((x, i) => {
                        return (
                            <div className='CompanyDetails'>
                                {
                                    i == editIndex
                                        ?
                                        <>
                                            <div
                                                className='p-4'
                                                style={{ borderRadius: '12px', border: '1px #eff2f5 solid' }}
                                            >
                                                <div className='p-4' style={{ display: 'flex', gap: '20px', alignItems: 'end' }}>


                                                    <div className={'row'} style={{ width: '100%' }}>
                                                        <div className='col '>
                                                            <h6 className='fw-bold required'>Select Section Category</h6>
                                                            <Select
                                                                options={subCategories}
                                                                placeholder='Select Category'
                                                                className={clsx(
                                                                    'text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect p-3 h-50px'
                                                                )}
                                                                styles={{
                                                                    menuList: (provided, state) => ({
                                                                        ...provided,
                                                                        height: 'auto',
                                                                        maxHeight: '200px',
                                                                    }),
                                                                }}
                                                                value={editData.Category}
                                                                onChange={e => {
                                                                    setEditData({ ...editData, Category: e })
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div style={{ width: '32px', height: '32px', }}>
                                                        <span
                                                            className='svg-icon flex svg-icon-danger bg-danger bg-opacity-5 w-30px h-30px rounded pointer'
                                                            onClick={() => {
                                                                console.log('delete');
                                                            }}
                                                        >
                                                            <KTSVG
                                                                className='svg-icon-3'
                                                                path={toAbsoluteUrl('/media/icons/Custom/Dustbin.svg')}
                                                            />
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className='separator my-4'></div>

                                                <div className='m-2'>
                                                    <div className='pe-5 '>
                                                        <div className='d-flex align-items-center justify-content-between'>
                                                            <div>
                                                                <h6 className='fw-normal'>DesktopSS Section View </h6>
                                                                <p
                                                                    className='text-gray-500'
                                                                    style={deskfetchErr ? { color: 'red' } : { color: 'green' }}
                                                                >
                                                                    {editData.componentDesktopSS && 'Upload screenshot'}
                                                                    {!editData.componentDesktopSS && 'Uplaoded Screenshot'}
                                                                    {manualWeb && 'Manually Uploaded'}
                                                                </p>
                                                            </div>
                                                            <div>
                                                                <button
                                                                    type='button'
                                                                    className={
                                                                        !editData.componentDesktopSS
                                                                            ? 'btn btn-gray-200 screenshotComponentBtn border border-gray-500'
                                                                            : 'screenshotComponentBtn'
                                                                    }
                                                                    disabled={editData.componentDesktopSS ? false : true}
                                                                    onClick={() => {
                                                                        window.open(editData.componentDesktopSS, '_blank')

                                                                    }}
                                                                >
                                                                    {editData.componentDesktopSS && (
                                                                        <img src={toAbsoluteUrl('/media/icons/Custom/eye.svg')} alt='eye' />
                                                                    )}
                                                                    &nbsp; Preview
                                                                </button>

                                                                <button
                                                                    type='button'
                                                                    className='btn btn-gray-200 screenshotComponentBtn border border-gray-500 w-200px mx-4 cursor-pointer'
                                                                    onClick={() => {
                                                                        document.getElementById('desktopManual' + i).click()
                                                                    }}
                                                                >
                                                                    Click to {manualWeb ? 'Re-Uplaod' : 'Upload'}
                                                                </button>
                                                                <input
                                                                    type='file'
                                                                    accept='.png, .jpg, .jpeg, .svg'
                                                                    style={{ display: 'none' }}
                                                                    id={'desktopManual' + i}
                                                                    onChange={(e) => onChangeEdit(e)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='m-2'>
                                                    <div className='pe-5 '>
                                                        <div className='d-flex align-items-center justify-content-between'>
                                                            <div>
                                                                <h6 className='fw-normal'>MobileSS Section View </h6>
                                                                <p className='text-gray-500'>
                                                                    {editData.componentMobileSS && 'Upload screenshot'}
                                                                    {!editData.componentMobileSS && 'Uplaoded Screenshot'}
                                                                    {manualWeb && 'Manually Uploaded'}
                                                                </p>
                                                            </div>
                                                            <div>
                                                                <button
                                                                    type='button'
                                                                    className={
                                                                        !(editData.componentMobileSS)
                                                                            ? 'btn btn-gray-200 screenshotComponentBtn border border-gray-500'
                                                                            : 'screenshotComponentBtn'
                                                                    }
                                                                    onClick={() => {
                                                                        window.open(editData.componentMobileSS, '_blank')
                                                                    }}
                                                                    disabled={!editData.componentMobileSS}
                                                                >
                                                                    {editData.componentMobileSS && (
                                                                        <img src={toAbsoluteUrl('/media/icons/Custom/eye.svg')} alt='eye' />
                                                                    )}
                                                                    &nbsp; Preview
                                                                </button>

                                                                <button
                                                                    type='button'
                                                                    className='btn btn-gray-200 screenshotComponentBtn border border-gray-500 w-200px mx-4 cursor-pointer'
                                                                    onClick={() => {
                                                                        document.getElementById('mobileManual' + i).click()
                                                                    }}
                                                                >
                                                                    Click to {manualMob ? 'Re-Uplaod' : 'Upload'}
                                                                </button>
                                                                <input
                                                                    type='file'
                                                                    accept='.png, .jpg, .jpeg, .svg'
                                                                    style={{ display: 'none' }}
                                                                    id={'mobileManual' + i}
                                                                    onChange={(e) => onChangeMobileEdit(e)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className='mt-6'>
                                                <div className="row">
                                                    <div className="col">
                                                        <p className='required'>Section Phrases (comma separated values)</p>

                                                        <Input
                                                            type='text'
                                                            placeholder='Enter Phrase'
                                                            className='form-control-solid rounded-6 border shadow-none pe-6 bg-white-100 mb-5'
                                                            onChange={(e) => {
                                                                console.log(e)
                                                                setPhraseInputEdit(e.target.value)
                                                            }
                                                            }
                                                            name='phraseInput'
                                                            onKeyUp={e => {
                                                                e.preventDefault()
                                                                if (e.key == 'Enter') {
                                                                    if (phraseInputEdit.length <= 0) return;
                                                                    const arr = [...editData.componentPhrases]
                                                                    arr.push(phraseInputEdit)
                                                                    setPhraseInputEdit('')
                                                                    setEditData({ ...editData, componentPhrases: arr })
                                                                }
                                                            }}
                                                            value={phraseInputEdit}
                                                            prefix={
                                                                <>
                                                                    <img src={toAbsoluteUrl('/media/icons/Custom/Search.svg')} alt='link' />
                                                                </>
                                                            }
                                                        />

                                                    </div>
                                                </div>
                                                <div className='row pt-4 pe-5 '>
                                                    <div className='col d-flex flex-row  justify-content-start align-items-center flex-wrap'>
                                                        {editData.componentPhrases &&
                                                            editData.componentPhrases?.map((x, ind) => {
                                                                return (
                                                                    <div className='d-flex align-items-center justify-content-around border px-3 py-2 m-2 rounded-pill'>
                                                                        {x}
                                                                        <img
                                                                            style={{ paddingLeft: '5px', cursor: 'pointer', display: 'inline' }}
                                                                            onClick={() => {
                                                                                const arr = [...editData.componentPhrases]
                                                                                arr.splice(ind, 1)
                                                                                setEditData({ ...editData, componentPhrases: arr })
                                                                            }}
                                                                            src={toAbsoluteUrl('/media/icons/Custom/Cross.svg')}
                                                                            alt='cross'
                                                                        />
                                                                    </div>
                                                                )
                                                            })}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mt-5">
                                                <div className="d-flex align-items-center">
                                                    <button
                                                        onClick={() => {
                                                            handleEdit()
                                                        }}
                                                        className="btn fw-bolder btn-dark CompanyDetailButton">
                                                        Save
                                                    </button>
                                                    <button
                                                        onClick={() => {
                                                            setEditData({});
                                                            setEditIndex(-1);
                                                        }}
                                                        type='button' className='btn fw-bolder btn-gray-200 ms-5 CompanyDetailButton'>
                                                        Back
                                                    </button>

                                                </div>
                                            </div>
                                            {errorArray[i] && (
                                                <div className='fv-plugins-message-container'>
                                                    <div className='fv-help-block'>
                                                        <span className='text-danger' role='alert'>
                                                            Fill all the fields.
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                        :
                                        <>
                                            <div
                                                className='p-4'
                                                style={{ borderRadius: '12px', border: '1px #eff2f5 solid' }}
                                            >
                                                {counter.length > 1 && (
                                                    <span
                                                        className='cross cursor-pointer'
                                                        onClick={() => {
                                                            if (counter.length !== 1) {
                                                                let x = [...counter]
                                                                x.pop()
                                                                setCounter(x)
                                                                let y = [...values]
                                                                y.splice(i, 1)
                                                                setValues(y)
                                                                if (i < previous) {
                                                                    setPrevious((prev) => prev - 1)
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        &times;
                                                    </span>
                                                )}
                                                <div className='p-4' style={{ display: 'flex', gap: '20px', alignItems: 'end' }}>


                                                    <div className={'row'} style={{ width: '100%' }}>
                                                        <div className='col '>
                                                            <h6 className='fw-bold required'>Select Section Category</h6>
                                                            <Select
                                                                options={subCategories}
                                                                placeholder='Select Category'
                                                                className={clsx(
                                                                    'text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect p-3 h-50px'
                                                                )}
                                                                styles={{
                                                                    menuList: (provided, state) => ({
                                                                        ...provided,
                                                                        height: 'auto',
                                                                        maxHeight: '200px',
                                                                    }),
                                                                }}
                                                                value={values[i].Category}
                                                                onChange={e => {
                                                                    let temp = [...values]
                                                                    temp[i].Category = e
                                                                    setValues(temp)
                                                                }}
                                                                isDisabled={!((i == (values.length - 1)) || (i == editIndex))}
                                                            />
                                                        </div>
                                                    </div>


                                                    {
                                                        i != values.length - 1 &&
                                                        <>
                                                            <div style={{ width: '32px', height: '32px', }}>
                                                                <span
                                                                    className='svg-icon flex svg-icon-danger bg-danger bg-opacity-5 w-30px h-30px rounded pointer'
                                                                    onClick={() => {
                                                                        setDeleteId(values[i]._id)
                                                                        handleShow()
                                                                    }}
                                                                >
                                                                    <KTSVG
                                                                        className='svg-icon-3'
                                                                        path={toAbsoluteUrl('/media/icons/Custom/Dustbin.svg')}
                                                                    />
                                                                </span>
                                                            </div>
                                                            <Modal
                                                                show={show}
                                                                onHide={handleClose}
                                                                aria-labelledby='contained-modal-title-vcenter'
                                                                centered
                                                            >
                                                                <Modal.Header>
                                                                    <Modal.Title>Delete</Modal.Title>
                                                                </Modal.Header>
                                                                <Modal.Body>Are you sure you wanna delete?</Modal.Body>
                                                                <Modal.Footer>
                                                                    <button
                                                                        className='btn fw-bolder btn-gray-200 fs-6 dialogButton'
                                                                        onClick={() => {
                                                                            setShow(false)
                                                                            setDeleteId('')
                                                                        }}
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                    <button
                                                                        className='btn btn-primary fs-6 dialogButton ms-2'
                                                                        onClick={() => handleDelete(values[i]._id)}
                                                                    >
                                                                        Delete
                                                                    </button>
                                                                </Modal.Footer>
                                                            </Modal>
                                                            <div style={{ width: '32px', height: '32px', }}>
                                                                <span
                                                                    className='svg-icon flex svg-icon-dark bg-primary bg-opacity-5 w-30px h-30px rounded me-2 pointer'
                                                                    onClick={() => {
                                                                        setEditData(values[i])
                                                                        setEditIndex(i)
                                                                    }}
                                                                >
                                                                    <KTSVG
                                                                        className='svg-icon-3'
                                                                        path={toAbsoluteUrl('/media/icons/Custom/Pen.svg')}
                                                                    />
                                                                </span>
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                                <div className='separator my-4'></div>

                                                <div className='m-2'>
                                                    <div className='pe-5 '>
                                                        <div className='d-flex align-items-center justify-content-between'>
                                                            <div>
                                                                <h6 className=' fw-normal'>DesktopSS Section View</h6>
                                                                <p
                                                                    className='text-gray-500'
                                                                    style={deskfetchErr ? { color: 'red' } : { color: 'green' }}
                                                                >
                                                                    {!values[i].componentDesktopSS && 'Upload screenshot'}
                                                                    {values[i].componentDesktopSS && 'Uplaoded Screenshot'}
                                                                    {manualWeb && 'Manually Uploaded'}
                                                                </p>
                                                            </div>
                                                            <div>
                                                                <button
                                                                    type='button'
                                                                    className={
                                                                        !values[i].componentDesktopSS
                                                                            ? 'btn btn-gray-200 screenshotComponentBtn border border-gray-500'
                                                                            : 'screenshotComponentBtn'
                                                                    }
                                                                    disabled={values[i].componentDesktopSS ? false : true}
                                                                    onClick={() => {
                                                                        window.open(values[i].componentDesktopSS, '_blank')

                                                                    }}
                                                                >
                                                                    {values[i].componentDesktopSS && (
                                                                        <img src={toAbsoluteUrl('/media/icons/Custom/eye.svg')} alt='eye' />
                                                                    )}
                                                                    &nbsp; Preview
                                                                </button>
                                                                {((i == (values.length - 1)) || (i == editIndex)) && (
                                                                    <button
                                                                        type='button'
                                                                        className='btn btn-gray-200 screenshotComponentBtn border border-gray-500 w-200px mx-4 cursor-pointer'
                                                                        onClick={() => {
                                                                            document.getElementById('desktopManual' + i).click()
                                                                        }}
                                                                    >
                                                                        Click to {manualWeb ? 'Re-Uplaod' : 'Upload'}
                                                                    </button>
                                                                )}
                                                                <input
                                                                    type='file'
                                                                    accept='.png, .jpg, .jpeg, .svg'
                                                                    style={{ display: 'none' }}
                                                                    id={'desktopManual' + i}
                                                                    onChange={(e) => onChange(e, i)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='m-2'>
                                                    <div className='pe-5 '>
                                                        <div className='d-flex align-items-center justify-content-between'>
                                                            <div>
                                                                <h6 className=' fw-normal'>MobileSS Section View</h6>
                                                                <p className='text-gray-500'>
                                                                    {!values[i].componentMobileSS && 'Upload screenshot'}
                                                                    {values[i].componentMobileSS && 'Uplaoded Screenshot'}
                                                                    {manualWeb && 'Manually Uploaded'}
                                                                </p>
                                                            </div>
                                                            <div>
                                                                <button
                                                                    type='button'
                                                                    className={
                                                                        !(values[i].componentMobileSS)
                                                                            ? 'btn btn-gray-200 screenshotComponentBtn border border-gray-500'
                                                                            : 'screenshotComponentBtn'
                                                                    }
                                                                    onClick={() => {
                                                                        window.open(values[i].componentMobileSS, '_blank')
                                                                    }}
                                                                    disabled={!values[i].componentMobileSS}
                                                                >
                                                                    {values[i].componentMobileSS && (
                                                                        <img src={toAbsoluteUrl('/media/icons/Custom/eye.svg')} alt='eye' />
                                                                    )}
                                                                    &nbsp; Preview
                                                                </button>
                                                                {((i == (values.length - 1)) || (i == editIndex)) && (
                                                                    <button
                                                                        type='button'
                                                                        className='btn btn-gray-200 screenshotComponentBtn border border-gray-500 w-200px mx-4 cursor-pointer'
                                                                        onClick={() => {
                                                                            document.getElementById('mobileManual' + i).click()
                                                                        }}
                                                                    >
                                                                        Click to {manualMob ? 'Re-Uplaod' : 'Upload'}
                                                                    </button>
                                                                )}
                                                                <input
                                                                    type='file'
                                                                    accept='.png, .jpg, .jpeg, .svg'
                                                                    style={{ display: 'none' }}
                                                                    id={'mobileManual' + i}
                                                                    onChange={(e) => onChangeMobile(e, i)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='mt-6'>
                                                <div className="row">
                                                    <div className="col">
                                                        <p className='required'>Section Phrases (comma separated values)</p>
                                                        {
                                                            ((i == (values.length - 1)) || (i == editIndex))
                                                            &&

                                                            <Input
                                                                type='text'
                                                                placeholder='Enter Phrase'
                                                                className='form-control-solid rounded-6 border shadow-none pe-6 bg-white-100 mb-5'
                                                                onChange={(e) => {
                                                                    console.log(e)
                                                                    setPhraseInput(e.target.value)
                                                                }
                                                                }
                                                                name='phraseInput'
                                                                onKeyUp={e => {
                                                                    e.preventDefault()
                                                                    if (e.key == 'Enter') {
                                                                        if (phraseInput.length <= 0) return;
                                                                        const arr = [...values[i].componentPhrases]
                                                                        arr.push(phraseInput)
                                                                        setPhraseInput('')
                                                                        const arr2 = [...values]
                                                                        arr2[i].componentPhrases = arr
                                                                        setValues(arr2)
                                                                    }
                                                                }}
                                                                value={phraseInput}
                                                                prefix={
                                                                    <>
                                                                        <img src={toAbsoluteUrl('/media/icons/Custom/Search.svg')} alt='link' />
                                                                    </>
                                                                }
                                                            />
                                                        }

                                                    </div>
                                                </div>
                                                <div className='row pt-4 pe-5 '>
                                                    <div className='col d-flex flex-row  justify-content-start align-items-center flex-wrap'>
                                                        {values[i].componentPhrases &&
                                                            values[i].componentPhrases?.map((x, ind) => {
                                                                return (
                                                                    <div className='d-flex align-items-center justify-content-around border px-3 py-2 m-2 rounded-pill'>
                                                                        {x}
                                                                        <img
                                                                            style={{ paddingLeft: '5px', cursor: 'pointer', display: 'inline' }}
                                                                            onClick={() => {
                                                                                const arr = [...values[i].componentPhrases]
                                                                                arr.splice(ind, 1)
                                                                                const arr2 = [...values]
                                                                                arr2[i].componentPhrases = arr
                                                                                setValues(arr2)
                                                                            }}
                                                                            src={toAbsoluteUrl('/media/icons/Custom/Cross.svg')}
                                                                            alt='cross'
                                                                        />
                                                                    </div>
                                                                )
                                                            })}
                                                    </div>
                                                </div>
                                                {errorArray[i] && (
                                                    <div className='fv-plugins-message-container'>
                                                        <div className='fv-help-block'>
                                                            <span className='text-danger' role='alert'>
                                                                Fill all the fields.
                                                            </span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </>
                                }

                            </div>
                        )
                    })}



                    <div className='row pe-5 pb-5 ms-5'>
                        <span
                            className='fw-bold addpage'
                            onClick={() => {
                                submitForm()
                            }}
                        >
                            + Add Another Section
                        </span>
                    </div>

                    <div className='d-flex pt-4 pe-5'>
                        <button
                            type='submit'
                            id='kt_sign_up_submit'
                            className='btn btn-primary ms-5 CompanyDetailButton'
                            onClick={() => {
                                submitForm()
                            }}
                            disabled={loading || submitError}
                        >
                            {!loading && <span className='indicator-label'>Save</span>}
                            {loading && (
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                    Please wait...{' '}
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                            )}
                        </button>
                        {/* <button onClick={skipStep} className='btn btn-primary ms-5 CompanyDetailButton'>
            <span className='indicator-label'>Skip</span>
          </button> */}
                        <Link
                            to={{
                                pathname: '/website/add-components',
                            }}
                        >
                            <button type='button' className='btn fw-bolder btn-gray-200 ms-5 CompanyDetailButton'>
                                Back
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default AddComponents